import { FileMusic, Headphones, ScrollText, type LucideIcon } from 'lucide-react';
import type { FileKind } from '../../../shared/dto/library';
import { cx } from '../../components/ui';
import { useT, type MessageKey } from '../../i18n';

export const KIND_ICON: Record<FileKind, LucideIcon> = { sheet: FileMusic, audio: Headphones, lyrics: ScrollText };
export const KIND_LABEL: Record<FileKind, MessageKey> = { sheet: 'library.kind_sheet', audio: 'library.kind_audio', lyrics: 'library.kind_lyrics' };
const ORDER: FileKind[] = ['sheet', 'audio', 'lyrics'];

/** Small icons for the kinds a song has (sheet / audio / lyrics); optional counts for editors. */
export function KindIcons({ counts, showCounts, className }: { counts: Record<FileKind, number>; showCounts?: boolean; className?: string }) {
  const t = useT();
  const present = ORDER.filter((k) => counts[k] > 0);
  if (present.length === 0) return null;
  return (
    <span className={cx('inline-flex shrink-0 items-center gap-2 text-[var(--muted)]', className)}>
      {present.map((k) => {
        const Icon = KIND_ICON[k];
        const label = `${t(KIND_LABEL[k])}${showCounts ? ` (${counts[k]})` : ''}`;
        return (
          <span key={k} className="inline-flex items-center gap-0.5" title={label}>
            <Icon className="size-5" aria-hidden />
            {showCounts ? <span className="text-[14px] font-semibold tabular-nums">{counts[k]}</span> : null}
            <span className="sr-only">{label}</span>
          </span>
        );
      })}
    </span>
  );
}
